import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, ArrowLeft, Shield } from 'lucide-react';

export default function LegalPage() {
  return (
    <div className="min-h-screen bg-[#FDFCFB]">
      {/* Nav */}
      <nav className="sticky top-0 z-50 bg-white border-b border-[#E5E5E5]">
        <div className="max-w-4xl mx-auto px-6 h-14 flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 text-[#595959] hover:text-[#1C1C1C] transition-colors text-sm">
            <ArrowLeft className="h-4 w-4" />Back
          </Link>
          <div className="flex items-center gap-2">
            <GraduationCap className="h-5 w-5 text-[#2C4C3B]" />
            <span className="font-outfit text-base font-semibold text-[#1C1C1C]">FrameEd</span>
          </div>
        </div>
      </nav>

      <main className="max-w-3xl mx-auto px-6 py-16">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-xl bg-[#2C4C3B]/10 flex items-center justify-center">
            <Shield className="h-5 w-5 text-[#2C4C3B]" />
          </div>
          <div>
            <h1 className="font-outfit text-2xl font-semibold text-[#1C1C1C]">Legal & Intellectual Property Notice</h1>
            <p className="text-sm text-[#595959]">Simply SLPs, LLC</p>
          </div>
        </div>

        <div className="space-y-10 text-sm text-[#595959] leading-relaxed">
          {/* Copyright */}
          <section>
            <h2 className="text-xs font-bold uppercase tracking-wider text-[#1C1C1C] mb-3">Copyright</h2>
            <p>
              {'\u00A9'} 2026 Simply SLPs, LLC. All rights reserved.
            </p>
            <p className="mt-2">
              FrameEd, Frame Practice, Frame Interventions, Frame IEP/MET, Rubric Builder, Speech/Language Referral Manager, and all related products, software, designs, documentation, templates, workflows, and content are proprietary to Simply SLPs, LLC.
            </p>
          </section>

          {/* IP Protection */}
          <section>
            <h2 className="text-xs font-bold uppercase tracking-wider text-[#1C1C1C] mb-3">Intellectual Property Protection</h2>
            <p>
              The FrameEd platform, including all of its component products, source code, visual designs, user interface layouts, data models, workflow architectures, documentation, templates, and educational content, constitutes proprietary intellectual property of Simply SLPs, LLC.
            </p>
            <p className="mt-3">
              Unauthorized copying, reproduction, modification, distribution, resale, scraping, reverse engineering, or commercial use of any part of the FrameEd platform is strictly prohibited except as expressly permitted in writing by Simply SLPs, LLC.
            </p>
          </section>

          {/* Permitted Use */}
          <section>
            <h2 className="text-xs font-bold uppercase tracking-wider text-[#1C1C1C] mb-3">Permitted Use</h2>
            <p>
              Authorized users may access and use FrameEd products solely for their intended educational and professional purposes in accordance with any applicable license agreement, subscription terms, or written authorization from Simply SLPs, LLC.
            </p>
          </section>

          {/* Trademarks */}
          <section>
            <h2 className="text-xs font-bold uppercase tracking-wider text-[#1C1C1C] mb-3">Trademarks</h2>
            <p>
              FrameEd, Frame Practice, Frame Interventions, Frame IEP/MET, Rubric Builder, and Speech/Language Referral Manager are trademarks or service marks of Simply SLPs, LLC. Use of these marks without prior written permission is prohibited.
            </p>
          </section>

          {/* Contact */}
          <section>
            <h2 className="text-xs font-bold uppercase tracking-wider text-[#1C1C1C] mb-3">Contact</h2>
            <p>
              For licensing inquiries, permissions, or questions regarding intellectual property, please contact Simply SLPs, LLC.
            </p>
          </section>

          {/* Effective date */}
          <div className="pt-6 border-t border-[#E5E5E5]">
            <p className="text-[10px] text-[#999]">Effective date: January 1, 2026. Last updated: April 2026.</p>
          </div>
        </div>
      </main>
    </div>
  );
}
